import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import Footer from "../components/Footers";
import Header from "../components/Header";


const Policy = ()=>{

    const [isOpenInformation, setIsOpenInformation] = useState(true);
    const [isOpenPurpose, setIsOpenPurpose] = useState(true);
    const [isOpensharingInfo, setIsOpenSharingInfo] = useState(true);
    const [isOpenInternational, setIsOpenInternational] = useState(true);
    const [isOpenStoreData, setIsOpenStoreData] = useState(true);
    const [isOpenPersonalData, setIsOpenPersonalData] = useState(true);
    const [isOpenExercise, setIsOpenExercise] = useState(true);
    const [isOpenOTPOut, setIsOpenOTPOut] = useState(true);
    const [isOpenSecurity, setIsOpenSecurity] = useState(true);
    const [isOpenChildrenPrivacy, setIsOpenChildrenPrivacy] = useState(true);
    const [isOpenChangePrivacy, setIsOpenChangePrivacy] = useState(true);
    const [isOpenContactUs, setIsOpenContactUs] = useState(true);

    return (
        <div className="bg-levi-bg min-h-screen">
             <Header />
             <div className="relative w-full bg-levi-bg pt-32 pb-24 overflow-hidden border-b border-levi-border">
                <div className="absolute inset-0 bg-grid-red bg-[size:60px_60px] opacity-30" />
                <div className="absolute -top-32 right-0 w-[400px] h-[400px] bg-levi-primary/20 blur-[120px] rounded-full" />
                <div className="container-xl relative text-center">
                    <div className="flex items-center justify-center gap-3 mb-5">
                        <span className="h-px w-12 bg-levi-primary" />
                        <span className="eyebrow">Legal</span>
                        <span className="h-px w-12 bg-levi-primary" />
                    </div>
                    <h1 className="display-lg text-levi-text">Privacy Policy</h1>
                    <p className="mt-4 font-mono text-sm text-levi-muted tracking-widest uppercase">
                        Last updated · April 20, 2025
                    </p>
                </div>
            </div>

            <div className="max-w-[95%] sm:max-w-[80%] mx-auto sm:p-20 pt-8 px-4 bg-stone-50 border border-levi-border my-16"
               style={{
                boxShadow: "rgba(0, 0, 0, 0.5) 0px 20px 60px -20px"
              }}>

                <hr className="sm:my-12 mt-6 mb-16 border-gray-300" />

                <p className="mt-4 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                    Phuc Pham (“we,” “us” or “our”) takes your privacy seriously. This Privacy policy (“Privacy policy”)
                    explains our data protection policy and describes the types of information we may process when
                    you access and/or use the Website available at 
                    {" "} <a href="/" className="text-red-700 hover:underline"> https://web-levi.web.app </a>{" "} 
                    (here in after, the “Website”).
                </p>

                <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                    When we refer to personal data (or personal information) we mean any information of any kind
                    relating to a natural person who can be identified, directly or indirectly, in particular by reference
                    to such data. It is a natural person who can be identified directly or indirectly, in particular by
                    reference to an identification number or to one or more factors specific to his or her physical,
                    physiological, mental, economic, cultural or social status.
                </p>
                <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                    Our Privacy policy applies to all users and others who access the Website (“Users”).
                    For the purposes of the GDPR, we are the data controller, unless otherwise stated.
                </p>
                <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular uppercase">
                    Please read carefully the following privacy policy, for information regarding the ways your personal information may be processed. 
                    When you use the website you acknowledge that you have read, understood, and agreed to be bound by this privacy policy
                </p>

                <div className="mt-12 border-2 border-red-600 rounded-[16px] p-6 bg-white">
                    <p className="text-[#323232] sm:text-[20px] text-[18px] font-poppins font-semibold">
                        Mobile App Data Practices — On-Device Processing
                    </p>

                    <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                        This section applies to our mobile applications (including, among others,
                        photo, baby-prediction, image, face-analysis and similar creative apps such
                        as “Babylook: AI Predictor”). It governs how those apps handle your content
                        and takes precedence over the general website terms above for app data.
                    </p>

                    <ul className="text-[#323232] sm:text-[16px] text-[14px] font-poppins list-disc list-inside mt-3 space-y-2">
                        <li>
                            <span className="font-medium">All photo and image processing is performed entirely on your device.</span>
                            {" "}Image generation and face analysis run locally using Apple’s on-device
                            frameworks (Core Image and the Vision framework). No machine-learning or
                            generation happens on a server.
                        </li>
                        <li>
                            <span className="font-medium">Your photos and personal content are never uploaded, transmitted, or shared.</span>
                            {" "}The parent photos and any images you select never leave your device.
                            Generated results are stored only in local storage on your device.
                        </li>
                        <li>
                            <span className="font-medium">We do not send your data to any third-party AI service.</span>
                            {" "}These apps do not include, call, or transmit any data to a third-party
                            artificial-intelligence service or any external server for content generation
                            or analysis. No API keys, endpoints, or network requests are used for these
                            features — they work fully offline.
                        </li>
                        <li>
                            <span className="font-medium">No personal data is collected by these apps.</span>
                            {" "}We do not collect, sell, rent, or share the personal content you process
                            in the app. The third-party providers and analytics/advertising technologies
                            listed elsewhere in this policy apply to our website and to apps that explicitly
                            integrate them; they do not receive your photos or in-app content.
                        </li>
                    </ul>

                    <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                        In short: for these apps, what you create stays on your device. If you have any
                        questions about app data handling, contact us at
                        {" "} <span className="text-red-700 underline">tphuc.work@gmail.com</span>.
                    </p>
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenInformation(!isOpenInformation)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Information we process
                        </p>
                        {isOpenInformation ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenInformation && (
                        <>
                         <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            There are several categories of information that may be processed when you access and/or use the Website.
                        </p>
                

                        <p className="mt-3 text-[#AAAFB8] sm:text-[14px] text-[12px] font-poppins font-medium uppercase">
                            Information that you voluntarily provide to us  
                        </p>

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            We may collect, store and process some information about you when you use the form available within the “Contact us” section on 
                            the Website (hereinafter, “Contact us” form). In particular, if you decide to make a request via the “Contact us” form, the following 
                            categories of information are voluntarily provided by you: your name, email address, the text of your message and/or any files that 
                            you optionally choose to attach to your request. We use the services of Amazon Web Services, Inc. (a subsidiary of Amazon.com Inc.) 
                            or of Advanced Hosters B.V. in order to collect, store and process the information that you provide us via the “Contact us” form. 
                            We use the information submitted by you via the “Contact us” form solely for the purpose of considering and responding to your 
                            requests (if necessary). 
                        </p>
                        

                        <p className="mt-3 text-[#AAAFB8] sm:text-[14px] text-[12px] font-poppins font-medium uppercase">
                            Information that is processed automatically 
                        </p>

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            When you access and/or use the Website, some information about your device and your user behavior may be processed automatically. 
                            This information is generally non-personal, i.e. it does not, on its own, permit direct association with any specific individual, 
                            and we may access it only in aggregated form. We process this information on the ground of our <span className="font-medium italic">legitimate interest </span>  in improving our 
                            Website and giving our users the best experience. If we do not access such data we may not be able to provide you with all features 
                            of the Website.
                        </p>

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            We use third-party automatic data processing technologies to analyze certain information sent by your device via our Website 
                            (analytics or advertising tools). Some of them may launch automated processing of your personal data, including profiling, which means any 
                            form of automated processing of personal data used to evaluate certain personal aspects relating to you, in particular to analyze or 
                            predict aspects concerning your personal preferences, interests, behavior, location or movements (see the list of data described below). 
                            Processing information through automatic data processing technologies starts automatically when you first time access the Website.
                        </p>

                        <p className="mt-3 text-[#AAAFB8] sm:text-[14px] text-[12px] font-poppins font-medium uppercase">
                            Device Details
                        </p>

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px]  font-poppins font-regular">
                            When you use a device (computer, laptop / tablet / phone) to access our Website, some details about your device are reported, 
                            including “device identifiers”. Device identifiers are small data files or similar data structures stored on or associated with your device, 
                            which uniquely identify your device (but not your personality). Device identifier enables generalized reporting or personalized content and ads 
                            by the third parties.
                        </p>

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px]  font-poppins font-regular">
                            What data can be processed:
                        </p>

                        <ul className="text-[#323232] sm:text-[16px] text-[14px]  font-poppins list-disc list-inside mt-3">
                            <li className="mt-2">
                                Information about the device itself: type of your device, type of operating system and its version, model and manufacturer, 
                                screen size, screen density, orientation, audio volume and battery, device memory usage.
                            </li>
                            <li className="mt-2">
                                Information about the internet connection: mobile carrier, network provider, network type, IP address, timestamp and duration of sessions, 
                                speed, browser and version, browser language.  
                            </li>
                            <li className="mt-2">
                                Location-related information: IP address, the country code/ region/ state/ city associated with your SIM card or your device, language setting, 
                                time zone.    
                            </li>
                            <li className="mt-2">
                                Device identifiers: advertising identifiers, Identity For Advertisers for iOS devices/ Advertising ID or Android ID for Android devices.   
                            </li>
                        </ul>

                        <p className="mt-3 text-[#AAAFB8] sm:text-[14px] text-[12px] font-poppins font-medium uppercase">
                            Cookies and similar technologies
                        </p>

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            When you access and/or use the Website, cookies and similar technologies may be used (pixels, web beacons, scripts). 
                            A cookie is a text file containing small amounts of information which is downloaded to your device when you access the Website. The text file is 
                            then sent back to the server each time you use the Website. This enables us to operate the Website more effectively. For example, we will know 
                            how many users access specific areas, content or features within our Website and which links they clicked on. We use this aggregated information 
                            to understand and optimize how our Website is used, improve our marketing efforts, and provide content and features that are of interest to you. 
                            Third party analytics tools use cookies or similar technologies for the purpose of analyzing the Website traffic. 
                        </p>

                        <p className="mt-3 text-[#AAAFB8] sm:text-[14px] text-[12px] font-poppins font-medium uppercase">
                            Log file information
                        </p>

                        <p className="mt-3 text-[#323232]  sm:text-[16px] text-[14px]  font-poppins font-regular">
                            Log file information is automatically reported each time you make a request to access 
                            the Website. When you use our Website, analytics tools automatically record certain log file information, including time and date when you start 
                            and stop using the Website, and how you interact with the Website.
                        </p>

                        <p className="mt-3 text-[#323232]  sm:text-[16px] text-[14px]  font-poppins font-regular">
                            Information provided automatically to analytics or advertising tools does not generally come to our control, therefore, we cannot be responsible 
                            for processing such information. Please mind that some services are engaged in personal data profiling and may obtain information related to your 
                            personality and/or your device by using technologies that do not belong to our scope of responsibility.
                        </p>
                        
                        </>
                    )}
                </div>


                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenPurpose(!isOpenPurpose)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            The purposes of processing your data
                        </p>
                        {isOpenPurpose ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenPurpose && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                Our mission is to constantly improve our Website and provide you with better user experiences. As part of this mission, we use your information 
                                for the following purposes: 
                            </p>
                            
                            <ol className="list-decimal pl-6 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                <li className="mt-3">
                                    <span className="italic font-medium">To improve, test and monitor the effectiveness of our Website.</span>
                                    &nbsp;We use the information that is processed automatically to better understand user behavior and trends, detect potential outages and technical issues, 
                                    to operate, protect, improve, and optimize our Website.
                                </li>
                                <li className="mt-3">
                                    <span className="italic font-medium">To communicate with you. </span> We may use information that you voluntarily provide to us via the “Contact us” form available 
                                    on the Website for the purposes of processing and responding (if necessary) to your requests, receiving your feedback, comments or suggestions 
                                    about the Website or on other matters.   
                                </li>
                                <li className="mt-3">
                                    <span className="italic font-medium">To prevent fraud and spam, to enforce the law.</span>  We really want our Website to be free of spam and fraudulent content so that you 
                                    feel safe and free. We may use your information to prevent, detect, and investigate fraud, security breaches, potentially prohibited or illegal activities, protect our trademarks,
                                    enforce our Terms of Use and applicable law.
                                </li>
                            </ol>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                If any new purpose for processing your data arises, we will let you know when we start to process information on that other purpose 
                                by introducing the corresponding changes to this Privacy policy.  
                            </p>
                        </>
                    )}
                </div>
               

               
                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenSharingInfo(!isOpensharingInfo)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                          Sharing of your information
                        </p>
                        {isOpensharingInfo ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpensharingInfo && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We will not rent or sell your personal data to third parties, but we may share your information obtained via tools like cookies, log files, 
                                and device identifiers with third-party organizations that provide automatic data processing technologies for the Website. We do not control or 
                                influence these third parties’ tracking technologies or how they may be used.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                Please note that while we partner solely with third parties that gave us assurance of application of necessary technical and organizational measures 
                                to protect your data, we cannot guarantee the security of any information transmitted from the Website directly to such third parties. We are not 
                                responsible for any accidental loss or unauthorized access to your data through a fault of third parties.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We may engage the following third-party service providers in order to provide us with necessary infrastructure for delivery and improvement 
                                of our Website:
                            </p>

                            <div className="overflow-x-auto mt-8 rounded-t-[20px] border-gray-300 border">
                                <table className="min-w-full border-collapse">
                                    <thead >
                                        <tr className="bg-red-600 text-white text-left overflow-hidden text-[14px] font-sf font-medium border-gray-300 border-b">
                                            <th className="  px-4 py-4 overflow-hidden">ENTITY NAME</th>
                                            <th className=" px-4 py-4">SERVICES PERFORMED</th>
                                            <th className="px-4 py-4">ENTITY LOCATION</th>
                                            <th className=" px-4 py-4">LINK TO PRIVACY POLICY</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr className=" text-[#586379] font-poppins font-regular text-[14px] border-gray-300 border-b">
                                            <td className=" px-4 py-4">Apple Inc.</td>
                                            <td className="px-4 py-4">Cloud storage provider (for iOs devices)</td>
                                            <td className=" px-4 py-4">U.S.A.</td>
                                            <td className=" px-4 py-4 text-red-700 underline">
                                                <a href="https://www.apple.com/lae/privacy/" target="_blank" rel="noopener noreferrer">
                                                https://www.apple.com/lae/privacy/
                                                </a>
                                            </td>
                                        </tr>

                                        <tr className=" text-[#586379] font-poppins font-regular text-[14px] border-gray-300 border-b">
                                            <td className=" px-4 py-4">Firebase (Google LLC)</td>
                                            <td className="px-4 py-4">Analytics service provider</td>
                                            <td className=" px-4 py-4">U.S.A.</td>
                                            <td className=" px-4 py-4 text-red-700 underline">
                                                <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
                                                https://firebase.google.com/support/privacy
                                                </a>
                                            </td>
                                        </tr>


                                        <tr className=" text-[#586379] font-poppins font-regular text-[14px] border-gray-300 border-b">
                                            <td className=" px-4 py-4">Facebook Inc.</td>
                                            <td className="px-4 py-4">Analytics and marketing service provider</td>
                                            <td className=" px-4 py-4">U.S.A.</td>
                                            <td className=" px-4 py-4 text-red-700 underline">
                                                <a href="https://www.facebook.com/privacy/explanation" target="_blank" rel="noopener noreferrer">
                                                https://www.facebook.com/privacy/explanation
                                                </a>
                                            </td>
                                        </tr>


                                        <tr className=" text-[#586379] font-poppins font-regular text-[14px] border-gray-300 border-b">
                                            <td className="px-4 py-4">Google LLC</td>
                                            <td className="px-4 py-4">
                                                <p>Google Analytics (tool for analyzing Website traffic) </p>
                                                <p className="mt-4">Cloud storage (for Android devices)</p>
                                                
                                            </td>
                                            <td className="px-4 py-4">U.S.A.</td>
                                            <td className="px-4 py-4">
                                                <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer" className="underline text-red-700 ">
                                                https://policies.google.com/privacy?hl=en 
                                                </a>

                                                <p className="mt-4">
                                                <a href="https://support.google.com/analytics/answer/6004245" target="_blank" rel="noopener noreferrer" className="underline text-red-700 ">
                                                    https://support.google.com/analytics/answer/6004245 
                                                </a>
                                                    
                                                </p>

                                            </td>    
                                        </tr>

                                        <tr className=" text-[#586379] font-poppins font-regular text-[14px] border-gray-300 border-b">
                                            <td className=" px-4 py-4">Google Play Services.</td>
                                            <td className="px-4 py-4">Platform APIs, location, notifications, authentication</td>
                                            <td className=" px-4 py-4">U.S.A.</td>
                                            <td className=" px-4 py-4 text-red-700 underline">
                                                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                                                https://policies.google.com/privacy
                                                </a>
                                            </td>
                                        </tr>

                                        <tr className=" text-[#586379] font-poppins font-regular text-[14px] border-gray-300 border-b">
                                            <td className=" px-4 py-4">AdMob</td>
                                            <td className="px-4 py-4">In-app advertising services</td>
                                            <td className=" px-4 py-4">U.S.A.</td>
                                            <td className=" px-4 py-4 text-red-700 underline">
                                                <a href="https://support.google.com/admob/answer/6128543" target="_blank" rel="noopener noreferrer">
                                                https://support.google.com/admob/answer/6128543
                                                </a>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                            <p className="mt-12 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                As it is indicated above we use such services as Google Analytics. Metrica that track and report the Website traffic. Both services use different types of cookies 
                                to analyze user activity. If you want to learn more about the categories of data collected and processed by analytics service providers please consult the corresponding websites 
                                of Google Analytics. Metrica as well as their privacy policies and other documents concerning data protection. Note that we are not responsible for any usage of your data 
                                by the abovementioned third-party service providers in violation of our instructions.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                If you don’t want Google Analytics.Metrica to use cookies you can block data collection following the instructions provided in Section IX of the present Privacy policy.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                Our Website may contain links to third party sites/services. You also may visit the Website following a link from a third party site. We are not responsible for the privacy practices of 
                                these third-party sites or services linked, including for the information or content contained within them (unless we are the providers of those sites and/or services).
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We may disclose your personal information if it is needed for objective reasons, due to the public interest or in other unforeseen circumstances:
                            </p>
                            
                            <ol className="list-disc pl-6 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                <li className="mt-2">
                                    As required by law;
                                </li>
                                <li className="mt-2">
                                    When we believe, in good faith, that disclosure is necessary to protect our rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;  
                                </li>
                                <li className="mt-2">
                                    If we are involved in a merger, acquisition, or sale of all or a portion of our assets, you will be notified via prominent notice on our Website of any change in ownership or uses of 
                                    your personal information, as well as any choices you may have regarding your personal information;
                                </li>
                                <li className="mt-2">
                                    In some cases, we may share your information with our affiliates, subsidiaries, contractors, business partners or other third parties who perform services on our behalf.
                                </li>
                            </ol>
                        </>
                    )}
                </div>


                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenInternational(!isOpenInternational)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            International data transfers
                        </p>
                        {isOpenInternational ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenInternational && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We work in the cross-border area and provide our Website to Users around the world.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We and third-party organizations that provide automatic data processing technologies for the Website or our third-party partners may 
                                transfer the automatically processed information across borders and from your country or jurisdiction to other countries or jurisdictions 
                                around the world.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                If you are located in the European Union or other regions with laws governing data processing that may differ from U.S. law, 
                                please note that we may transfer information, including personal information, to a country and jurisdiction that may not have the same 
                                data protection laws as in your home jurisdiction. We try to make sure that the recipient of any personal data provides a proper protection 
                                of the personal data received, in accordance with the current legislation on the protection of such information.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                By using the Website, you agree that we may transfer your personal data to any third country, a territory or one or more specified sectors 
                                within that third country, or to the international organization where data protection and confidentiality regulations may not provide the same level 
                                of protection of personal data as your country does.
                            </p>
                        </>
                    )}
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenStoreData(!isOpenStoreData)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            How do we store your data
                        </p>
                        {isOpenStoreData ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenStoreData && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                For the purposes of data storage, we recourse to the services of the hosting organizations. We take your privacy seriously and, therefore, 
                                encrypt your personal data – if possible – before sending it to the hosting organizations for the purposes of its storage. Please note that we 
                                cooperate only with those hosting organizations that have passed our security and reliability check.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                In particular, we recourse to the services of Amazon Web Services, Inc. (a subsidiary of Amazon.com Inc.) and/or of Advanced Hosters B.V. 
                                that have adopted technical and organizational measures to protect your personal data against unauthorized/unlawful processing and accidental loss, 
                                destruction or other damage.
                            </p>
                        </>
                    )}
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenPersonalData(!isOpenPersonalData)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            How long we use your persional data
                        </p>
                        {isOpenPersonalData ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenPersonalData && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We will generally keep your personal information for as long as we need it for a lawful purpose: to perform the contract between you and us 
                                (enforce our Terms of Use) and to comply with our legal obligations. If you no longer want us to use your information that we physically 
                                access and store, you can request that we erase it.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                However, some data may still be stored for a certain time period (but no longer than the storage purpose requires) with a purpose of compliance 
                                with certain legal obligations (such as taxation, accounting, audit), maintenance of safety and data backup settings or prevention of fraud or 
                                other malicious acts.
                            </p>
                        </>
                    )}
                </div>
               

               
                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenExercise(!isOpenExercise)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Exercising your rights
                        </p>
                        {isOpenExercise ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenExercise && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                Applicable data protection laws give you certain rights regarding your personal information. You have the following rights in relation 
                                to your personal information that was collected:
                            </p>

                            <ol className="list-disc pl-6 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                <li className="mt-2">
                                    <span className="font-medium italic">Data Access and Portability. </span>You can request copies of your personal information.
                                </li>
                                <li className="mt-2">
                                    <span className="font-medium italic">Change or Correct Data.</span> Where you cannot update data by yourself, you have the right to ask to correct, change, update or rectify your data. 
                                </li>
                                <li className="mt-2">
                                    <span className="font-medium italic">Data Retention and Deletion.</span> Specific retention times can vary based on context of the processing performed. You have the right to ask to 
                                    delete all or some of the personal data that is held about you.  
                                </li>
                                <li className="mt-2">
                                    <span className="font-medium italic">Restriction of Processing. </span>Under certain circumstances, you may have the right to limit the ways in which your personal information is used. 
                                </li>
                            </ol>


                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                To exercise any of the rights described above, you can contact us at 
                                {" "} <span className="text-red-700 underline cursor-pointer"> tphuc.work@gmail.com</span>{" "} 
                                Please bear in mind that we ensure the above mentioned rights only with respect to the information that we physically access and store. 
                                We also would like to draw your attention to the fact that in order to process your request we first have to identify you as a user of our Website. 
                                When your information is processed automatically you may object to such processing in some circumstances. Where your information is processed for direct marketing purposes, 
                                you may ask to cease processing your data for these direct marketing purposes. In order to exercise this right please contact the third party service providers listed in the 
                                Section IV of this Privacy policy to learn how you can object to processing your data. Most of them have clear instructions on their privacy pages, functional API or other options.
                            </p>
                        </>
                    )}
                </div>


                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenOTPOut(!isOpenOTPOut)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            How to OTP out
                        </p>
                        {isOpenOTPOut ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenOTPOut && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                You may prevent and/or manage the collection and processing of data related to your use of the Website following the instructions provided below.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                Google Analytics. If you want to opt-out of being tracked by Google Analytics you can install and enable 
                                {" "} <a href="https://tools.google.com/dlpage/gaoptout/?hl=en" className="text-red-700 underline"  target="_blank"
                                rel="noopener noreferrer"> Google Analytics Opt-out Browser Add-on. </a>{" "} 
                                
                                Additionally, you can manage cookies and/or delete cookies already set by Google Analytics through your browser settings. Further information on 
                                Google Analytics’ data practices and relevant instructions can be found at 
                                {" "} <a href="https://support.google.com/analytics/answer/6004245" className="text-red-700 underline"  target="_blank"
                                rel="noopener noreferrer"> https://support.google.com/analytics/answer/6004245 </a>{" "} 
                                (see section ‘Information for Visitors of Sites and Apps Using Google Analytics’).
                            </p> 

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                Bear in mind that if you choose to disable all cookies, this can affect the Website functions, some of the features that make the Website more efficient may not function.
                            </p>
                        </>
                    )}
                </div>



                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenSecurity(!isOpenSecurity)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Security
                        </p>
                        {isOpenSecurity ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenSecurity && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px]  font-poppins font-regular">
                                The security of your personal information is highly important to us. We follow generally accepted industry standards to protect the personal information provided to us, 
                                both during transmission and once we receive it.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px]  font-poppins font-regular">
                                We take reasonable and appropriate measures to protect personal information from loss, misuse and unauthorized access, disclosure, alteration and destruction, 
                                taking into account the risks involved in the processing and the nature of the personal information.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px]  font-poppins font-regular">
                                We implement appropriate technical and organizational measures, which are designed to implement data-protection principles, such as data minimization, 
                                in an effective manner and to integrate the necessary safeguards into the processing.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px]  font-poppins font-regular">
                                Unfortunately, no method of transmission over the Internet, or method of electronic storage, is 100% secure. We do our best to protect your personal data, nevertheless, 
                                we cannot guarantee its absolute security. In the event that your personal information is compromised as a breach of security, we will promptly notify you in compliance with applicable law.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px]  font-poppins font-regular">
                                If you have any questions about the security of our Website, you can contact us at 
                                {" "} <span className="text-red-700 underline cursor-pointer"> tphuc.work@gmail.com </span>{" "} 
                            </p>

                        </>
                    )}
                </div>
                    
                
                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenChildrenPrivacy(!isOpenChildrenPrivacy)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Children’s privacy
                        </p>
                        {isOpenChildrenPrivacy ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenChildrenPrivacy && (
                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                        Our Website is not intended for children under the age of 18. Therefore, we do not knowingly collect or solicit any personal information from children under 18. No one under the age of 18 
                        may provide any personal information to the Website. If you are under 18, do not use or provide any information on this Website or through any of its features. Do not provide any information 
                        about yourself, including your email address. If we learn that we have collected personal information from a child under the age of 18 without verification of parental consent, we will erase 
                        that information as quickly as possible. If you believe that we might have any information from or about a child under 18, please contact us.
                    </p>
                    )}
                </div>

      
                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenChangePrivacy(!isOpenChangePrivacy)}
                    >
                        <p className="text-[#323232] text-[18px] font-poppins font-semibold">
                            Changes to the privacy policy
                        </p>
                        {isOpenChangePrivacy ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenChangePrivacy && (
                        <p className="mt-3 text-[#323232] text-[16px] font-poppins font-regular">
                        In case we change our Policy, we will post the changes on this page.
                        Please check our Website regularly for any changes.
                        </p>
                    )}
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenContactUs(!isOpenContactUs)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            How to contact us
                        </p>
                        {isOpenContactUs ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenContactUs && (
                         <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            If you have any questions about this Privacy policy, please feel free to contact us at 
                            {" "} <span className="text-red-700 underline cursor-pointer">  tphuc.work@gmail.com </span>{" "}
                        </p>
                    )}
                </div>
               

            </div>

              <Footer />
        </div>
    )
}

export default Policy;